/*
 *
 * Artifactory is a binaries repository manager.
 * Copyright (C) 2018 JFrog Ltd.
 *
 * Artifactory is free software: you can redistribute it and/or modify
 * it under the terms of the GNU Affero General Public License as published by
 * the Free Software Foundation, either version 3 of the License, or
 *  (at your option) any later version.
 *
 * Artifactory is distributed in the hope that it will be useful,
 * but WITHOUT ANY WARRANTY; without even the implied warranty of
 * MERCHANTABILITY or FITNESS FOR A PARTICULAR PURPOSE.  See the
 * GNU Affero General Public License for more details.
 *
 * You should have received a copy of the GNU Affero General Public License
 * along with Artifactory.  If not, see <http://www.gnu.org/licenses/>.
 *
 */

import ArtifactsModel from '../../../../../../modules/distribution/core/models/distribution/ArtifactsModel';
import ViewHelpers from '../../../../../../modules/distribution/core/utils/view.helpers';


export default class BundlePageComponent {
    constructor() {
        this.template = require('./bundle_page.html');
        this.controller = BundlePageController;
    }
}
BundlePageComponent.META = {
    name: 'bundlePage',
    state: {
        name: 'bundlePage',
        url: '/bundles/target/:bundle/:version?tab',
        params: {
            type: 'target',
            tab: 'content'
        },
        template: '<bundle-page></bundle-page>',
        parent: 'app-layout'
    }
};

class BundlePageController {
    constructor($scope, $timeout, $filter, $state, $stateParams, $location, BundlesDao, JFrogUIUtils, JFrogModal,
                JFrogNotifications, BundleDeleteService, User, ArtifactoryFeatures, $q) {
        this.$scope = $scope;
        this.$filter = $filter;
        this.$state = $state;
        this.$timeout = $timeout;
        this.$q = $q;
        this.$stateParams = $stateParams;
        this.BundlesDao = BundlesDao;
        this.$location = $location;
        this.JFrogUIUtils = JFrogUIUtils;
        this.BundlesDao = BundlesDao;
        this.artifactoryModal = JFrogModal;
        this.ArtifactoryFeatures = ArtifactoryFeatures;
        this.notifications = JFrogNotifications;
        this.BundleDeleteService = BundleDeleteService;
        this.routes = window.store.getters["distribution/GET_ROUTE_CONSTANTS"];
        this.items = [{
            text: 'Received',
            to: {
                name: this.routes.DISTRIBUTION_MAIN,
                params: {activeTab: 'target'}
            }
        }, {
            text: this.$stateParams.bundle,
            to: {
                name: this.routes.RECEIVED.RELEASE_BUNDLE,
                params: { bundle: this.$stateParams.bundle }
            }
        },{
            text: this.$stateParams.version,
            active:true
        }];
        this.user = User.getCurrent();
    }

    resolveBundleVersion() {
        let deferred = this.$q.defer();
        if(!this.ArtifactoryFeatures.isEnterprisePlus() && !this.ArtifactoryFeatures.isEdgeNode()) {
            deferred.reject();
            window.$vueRouter.push({
                name: this.routes.DISTRIBUTION_MAIN,
                params: {activeTab: 'target'}
            });
            return deferred.promise;
        }
        this.BundlesDao.getBundleVersions({$no_spinner: true},{
            type: this.$stateParams.type,
            name: this.$stateParams.bundle
        }).$promise.then((data) => {
            if(!data || !data.versions || data.versions.length === 0){
                deferred.reject();
                window.$vueRouter.push({ name: '404' });
            } else {
                deferred.resolve(data);
            }
        }).catch(() => {
            deferred.reject();
            window.$vueRouter.push({ name: '404' });
        });
        return deferred.promise;
    }

    $onDestroy() {
        this.hideSpinner();
    }

    $onInit() {
        this.showSpinner();
        this.resolveBundleVersion().then(bundle => {
            this.bundle = bundle;
            this._getBundleVersions();
            this.fileInfo = [];
            this.tabs = [
                {name: 'content'},
                {name:'effectivePermissions', isVisible: this.isPrivilegedUser()}
            ];

            this.tabsDict = {
                content: 'Content',
                effectivePermissions: 'Effective Permissions'
            };
        });
    }

    showSpinner() {
        window.store.dispatch('ENABLE_LOCAL_LOADER','.bundles-page-wrapper');
    }

    hideSpinner() {
        window.store.dispatch('DISABLE_LOCAL_LOADER','.bundles-page-wrapper');
    }

    _getBundleVersions() {
        this.versions = _.sortBy(this.bundle.versions, i => -i.created);

        // Go to first version if version isn't exist
        let versionsList = this.versions.map(version => version.version);
        if (!_.contains(versionsList, this.$stateParams.version)) {
            this.goToVersion(this.versions[0]);
        }
        this._getBundleData(this.$stateParams.type, this.$stateParams.bundle, this.$stateParams.version);
    }

    _getBundleData(type, name, version) {
        this.showSpinner();
        this.BundlesDao.getBundleData({$no_spinner: true}, {type,name,version}).$promise.then((data) => {
            data.formattedCreatedDate = ViewHelpers.formatDate(data.created);
            this.artifacts_view_model = new ArtifactsModel(data.artifacts.map(artifact => {
                return {
                    fileName: artifact.name,
                    targetPath: artifact.path,
                    fileSize: artifact.size,
                    type: artifact.component_version || 'file',
                    properties: []
                }
            }), null, data.numberOfArtifacts);

            this.summaryColumns = this.getSummaryColumns();
            this.bundleData = data;
            // TODO: Get storing repo from backend & export defaultStoringRepo const
            this.storingRepo = data.storing_repository || "release-bundles";
            this.hideSpinner();
        }).catch(() => {
            this.hideSpinner();
            window.$vueRouter.push({ name: '404' });
        });
    }

    updateFileInfo(selectedArtifactInfo, scrpllTop = false) {
        this.selectedArtifactInfo = selectedArtifactInfo;
        this.fileInfo = [
            {
                label: 'File Name',
                value: selectedArtifactInfo.fileName,
                isHidden: !selectedArtifactInfo.fileName
            },
            {
                label: 'Target Path',
                value: selectedArtifactInfo.targetPath,
                copy: true,
                isHidden: !selectedArtifactInfo.targetPath
            },
            {
                label: 'Created',
                value: selectedArtifactInfo.created,
                isHidden: !selectedArtifactInfo.created
            },
            {
                label: 'Size',
                value: this.formatFileSize(selectedArtifactInfo.fileSize),
                isHidden: _.isUndefined(selectedArtifactInfo.fileSize)
            }
        ];

        if (scrpllTop) {
            $('.inner-data-wrapper > div').scrollTop(0);
        }
    }

    getSummaryColumns() {
        return [{
            label: 'Version',
            class: 'name',
            template: '{{$ctrl.bundleData.version}}',
            isActive: true
        },
            {
                label: 'Description',
                class: 'short-description',
                template: '{{$ctrl.bundleData.desc}}',
                isActive: '{{!!$ctrl.bundleData.desc.length}}',
                width: '2fr'
            },
            {
                label: 'Created',
                class: 'creation-date',
                template: '{{$ctrl.bundleData.formattedCreatedDate}}',
                isActive: true
            },
            {
                label: 'Size',
                class: 'size',
                template: '{{$ctrl.bundleData.size | filesize}}',
                isActive: true
            }]
    }

    deleteBundleVersion() {
        this.BundleDeleteService.deleteBundleVersion(
            this.$stateParams.bundle,
            this.$stateParams.version,
            this.onDeleteSucess.bind(this)
        );
    }

    onDeleteSucess() {
        window.$vueRouter.push({
            name: this.routes.DISTRIBUTION_MAIN,
            params: {activeTab: 'target'}
        });
    }

    goToVersion(version) {
        _.extend(this.$stateParams, {
            type: this.$stateParams.type,
            version: version.version,
            bundle: this.$state.params.bundle
        });

        this.$state.go('.', this.$stateParams,
            {location: true, inherit: true, relative: this.$state.$current, notify: false, reload: true})
            .then(() => {
                this._getBundleData(this.$stateParams.type, this.$stateParams.bundle, this.$stateParams.version)
            });
    }

    formatFileSize(bytes) {
        return this.$filter('filesize')(bytes);
    }

    backToBundles(type) {
        window.$vueRouter.push({
            name: this.routes.RECEIVED.RELEASE_BUNDLE
        });
    }

    isPrivilegedUser() {
        return this.user.canManage || this.user.isAdmin();
    }
}



// WEBPACK FOOTER //
// ./states/bundles/components/bundles/recieved/bundle/bundle_page.component.js